import { render, staticRenderFns } from "./TasksNotifications.vue?vue&type=template&id=611c8829&"
import script from "./TasksNotifications.vue?vue&type=script&lang=js&"
export * from "./TasksNotifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports